<mat-card appearance="outlined">
    <mat-card-header>
        <mat-card-title>Danger Zone</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        @if (client$ | async; as client) {
            <div class="flex column">
                @if (client.is_paid && !hosted) {
                    <div class="flex row item">
                        <div class="flex column item">
                            <h3>Cancel Subscription</h3>
                            <p>
                                Cancel your subscription, this will remove all users except the
                                admin and reduce the storage limit back to 1GB. If you have more
                                content than that, you will be unable to upload new content.
                            </p>
                        </div>
                        <div>
                            <button
                                mat-stroked-button
                                color="accent"
                                (click)="confirmCancel(client.id)"
                            >
                                Cancel Subscription
                            </button>
                        </div>
                    </div>
                }
                <div class="flex row item">
                    <div class="flex column item">
                        <h3>Transfer Ownership</h3>
                        <p>
                            This will transfer the owernship of this workspace to another user in
                            this workspace
                        </p>
                    </div>
                    <div>
                        <button
                            mat-stroked-button
                            color="warn"
                            (click)="confirmTransfer(client.id)"
                        >
                            Transfer
                        </button>
                    </div>
                </div>
                <div class="flex row item">
                    <div class="flex column item">
                        <h3>Delete Workspace</h3>
                        <p>This will permanently delete this workspace</p>
                    </div>
                    <div>
                        <button mat-stroked-button color="warn" (click)="confirmDelete(client.id)">
                            Delete Workspace
                        </button>
                    </div>
                </div>
            </div>
        }
    </mat-card-content>
</mat-card>
